import { PropsWithChildren, ReactNode } from "react"
import classNames from "classnames"
import styled from "styled-components"

import { ApiTypes } from "types"
import styles from "assets/scss/index.module.scss"

import { MiniPagination } from "components/common/MiniPagination"
import { Spinner } from "components/common/Spinner"
import { ButtonNew } from "components/form/ButtonNew"

const WidgetAddress = styled.span`
  font-size: 0.75rem;
  color: #0f172a;
  font-weight: 400;
  font-size: 16px;
`

interface Props extends PropsWithChildren {
  isFetching?: boolean
  buttonText?: string
  title?: string
  address?: string
  className?: string
  tag?: number
  tagName?: string
  tagContent?: ReactNode
  pagination?: ApiTypes.Model.Pagination
  onButtonClick?: () => void
}

export const WidgetLayout = ({
  children,
  title,
  isFetching,
  buttonText,
  className,
  address,
  tag,
  tagName = "Devices",
  tagContent,
  onButtonClick,
  pagination,
}: Props) => {
  return (
    <div className={classNames(styles.widgetWrapper, className)}>
      <header className={styles.widgetHeader}>
        <h3 className={styles.widgetTitle}>{title}</h3>
        {address && <WidgetAddress>{address}</WidgetAddress>}
        {buttonText && <ButtonNew onClick={onButtonClick}>{buttonText}</ButtonNew>}
        {tagContent ? (
          <div className={styles.widgetTag}>{tagContent}</div>
        ) : (
          Boolean(tag) && (
            <div className={styles.widgetTag}>
              {tagName} <span className={styles.widgetTagValue}>{tag}</span>
            </div>
          )
        )}
        {!!pagination && <MiniPagination meta={pagination} />}
      </header>
      <div className={styles.widgetDataWrapper}>
        {children}
        {isFetching && (
          <div className={styles.widgetSpinnerWrapper}>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  )
}
